const UNDEFINED_PROCESS_INIT = "/init/undefined";

export const buildProspectProcessUrl = (generatedUrl, sourceId) => {
  const fallbackUrl = sourceId
    ? `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${sourceId}`
    : "";
  if (!generatedUrl || generatedUrl.indexOf(UNDEFINED_PROCESS_INIT) !== -1) {
    return fallbackUrl;
  }
  return generatedUrl;
};

export const isProspectSourceMissing = (shouldAddLinks, sourceId) =>
  Boolean(shouldAddLinks) && !sourceId;
